module.exports = __webpack_public_path__ + "static/media/kc-logo.458e0565.svg";